"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Route = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const transformToDate_1 = require("../transformers/transformToDate");
const Country_1 = require("./Country");
const DriverRouteAdditionalDistance_1 = require("./DriverRouteAdditionalDistance");
const Location_1 = require("./Location");
const RouteLandingContent_1 = require("./RouteLandingContent");
const RouteLocation_1 = require("./RouteLocation");
const UpsellRoute_1 = require("./UpsellRoute");
const VehicleTypePriceFee_1 = require("./VehicleTypePriceFee");
const Waypoint_1 = require("./Waypoint");
let Route = class Route {
    _id = (0, uuid_1.v4)();
    isGenerated = false; // the route was generated automatically and not updated since
    isAutoGenerated = false; // the route was generated automatically
    isVisited = false; // the route has been visited by a customer at least once
    isReviewed = false; // the route was manually reviewed by a content manager
    isReady = false;
    isLive = false;
    isSuggested = false;
    isApiAvailable = true;
    isAirportTransfer = false;
    isMeetAndGreet = true;
    originLocationId;
    originLocationMachineName;
    originLocationMachineNameWithCountry;
    originLocation;
    destinationLocationId;
    destinationLocationMachineName;
    destinationLocationMachineNameWithCountry;
    destinationLocation;
    isOtherDirection;
    isBidirectional = true;
    type = legacy_enums_1.RouteType.Car;
    tollPrice = 0;
    tollFee = 0;
    additionalPrice = 0;
    additionalFee = 0;
    driverAdditionalDistance;
    /**
     * @deprecated Not used anywhere. Stopped using Google Maps API call to populate it.
     */
    publicTransportDuration = null; // null = unknown
    pricingCountryId;
    pricingCountry;
    pricingRegionId;
    pricingCurrency = legacy_enums_1.Currency.Euro;
    note = "";
    vehicleTypesPricesFees = [];
    locations = [];
    stopLocations = [];
    waypoints = [];
    reviewIds = [];
    tagIds = [];
    upsellRoutes = [];
    upsellRoutesInOtherDirection = [];
    landingContent = {};
    priority = 0;
    bookingCount = 0;
    availableFrom;
    upsellReturnTrip = false;
    upsellReturnTripInOtherDirection = false;
    createdBy;
    createdAt = new Date();
    pricesRecalculatedAt;
    noMeetAndGreetApiPartnerIds = [];
};
exports.Route = Route;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Route.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Route.prototype, "isGenerated", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)() // differs from the above in that it's part of the second batch of auto-generated routes
    ,
    __metadata("design:type", Boolean)
], Route.prototype, "isAutoGenerated", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Route.prototype, "isVisited", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Route.prototype, "isReviewed", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Route.prototype, "isReady", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Route.prototype, "isLive", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Route.prototype, "isSuggested", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Route.prototype, "isApiAvailable", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Route.prototype, "isAirportTransfer", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Route.prototype, "isMeetAndGreet", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], Route.prototype, "originLocationId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], Route.prototype, "originLocationMachineName", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], Route.prototype, "originLocationMachineNameWithCountry", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => Location_1.Location, { nullable: true }),
    __metadata("design:type", Location_1.Location)
], Route.prototype, "originLocation", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], Route.prototype, "destinationLocationId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], Route.prototype, "destinationLocationMachineName", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], Route.prototype, "destinationLocationMachineNameWithCountry", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => Location_1.Location, { nullable: true }),
    __metadata("design:type", Location_1.Location)
], Route.prototype, "destinationLocation", void 0);
__decorate([
    (0, type_graphql_1.Field)({ defaultValue: false }),
    __metadata("design:type", Boolean)
], Route.prototype, "isOtherDirection", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Route.prototype, "isBidirectional", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Route.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Route.prototype, "tollPrice", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Route.prototype, "tollFee", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Route.prototype, "additionalPrice", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Route.prototype, "additionalFee", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => DriverRouteAdditionalDistance_1.DriverRouteAdditionalDistance),
    __metadata("design:type", Array)
], Route.prototype, "driverAdditionalDistance", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Transform)(({ value }) => (value == null ? null : Number(value))),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Route.prototype, "publicTransportDuration", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Route.prototype, "pricingCountryId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Country_1.Country),
    __metadata("design:type", Country_1.Country)
], Route.prototype, "pricingCountry", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Route.prototype, "pricingRegionId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Route.prototype, "pricingCurrency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Route.prototype, "note", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => [VehicleTypePriceFee_1.VehicleTypePriceFee]),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => VehicleTypePriceFee_1.VehicleTypePriceFee),
    __metadata("design:type", Array)
], Route.prototype, "vehicleTypesPricesFees", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => [Location_1.Location]),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => RouteLocation_1.RouteLocation),
    __metadata("design:type", Array)
], Route.prototype, "locations", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Location_1.Location),
    __metadata("design:type", Array)
], Route.prototype, "stopLocations", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Waypoint_1.Waypoint),
    __metadata("design:type", Array)
], Route.prototype, "waypoints", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], Route.prototype, "reviewIds", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], Route.prototype, "tagIds", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => UpsellRoute_1.UpsellRoute),
    __metadata("design:type", Array)
], Route.prototype, "upsellRoutes", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => UpsellRoute_1.UpsellRoute),
    __metadata("design:type", Array)
], Route.prototype, "upsellRoutesInOtherDirection", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => RouteLandingContent_1.RouteLandingContent, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Object),
    __metadata("design:type", Object)
], Route.prototype, "landingContent", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Route.prototype, "priority", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Route.prototype, "bookingCount", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Route.prototype, "availableFrom", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Route.prototype, "upsellReturnTrip", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Route.prototype, "upsellReturnTripInOtherDirection", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Route.prototype, "createdBy", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Route.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Route.prototype, "pricesRecalculatedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], Route.prototype, "noMeetAndGreetApiPartnerIds", void 0);
exports.Route = Route = __decorate([
    (0, type_graphql_1.ObjectType)("Route"),
    (0, type_graphql_1.InputType)("RouteInput"),
    (0, typeorm_1.Entity)("routes")
], Route);
//# sourceMappingURL=Route.js.map